var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "Bcp" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    { attrs: { "item-key": "Code", error: _vm.$v.form.Code } },
                    [
                      _c("NextInput", {
                        attrs: { type: "text", disabled: true },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: { type: "text", disabled: true },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: {
                          type: "number",
                          disabled: _vm.insertReadonly.StatusId,
                          toggle: ""
                        },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("insert.bcp.Bcp"), active: "" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "DiscountGroup7Id",
                            error: _vm.$v.form.DiscountGroup7Id
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: true,
                              label: "Label",
                              "lookup-key": "CUSTOMER_DISCOUNT_GROUP_7"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "DiscountGroup7Id",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.DiscountGroup7,
                              callback: function($$v) {
                                _vm.DiscountGroup7 = $$v
                              },
                              expression: "DiscountGroup7"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: { "item-key": "Year", error: _vm.$v.form.Year }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: true,
                              label: "Label",
                              source: _vm.years
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("Year", $event)
                              }
                            },
                            model: {
                              value: _vm.Year,
                              callback: function($$v) {
                                _vm.Year = $$v
                              },
                              expression: "Year"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Month",
                            error: _vm.$v.form.Month
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: true,
                              label: "Label",
                              source: _vm.Months
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("Month", $event)
                              }
                            },
                            model: {
                              value: _vm.LabelMonth,
                              callback: function($$v) {
                                _vm.LabelMonth = $$v
                              },
                              expression: "LabelMonth"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "EndYear",
                            error: _vm.$v.form.EndYear
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.EndYear,
                              label: "Label",
                              source: _vm.years
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("EndYear", $event)
                              }
                            },
                            model: {
                              value: _vm.EndYear,
                              callback: function($$v) {
                                _vm.EndYear = $$v
                              },
                              expression: "EndYear"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "EndMonth",
                            error: _vm.$v.form.EndMonth
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.EndMonth,
                              label: "Label",
                              source: _vm.Months
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("EndMonth", $event)
                              }
                            },
                            model: {
                              value: _vm.LabelEndMonthh,
                              callback: function($$v) {
                                _vm.LabelEndMonthh = $$v
                              },
                              expression: "LabelEndMonthh"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CustomerRegion3Id",
                            error: _vm.$v.form.CustomerRegion3Id
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: true,
                              label: "Label",
                              "lookup-key": "CUSTOMER_REGION_3"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectBranch($event)
                              }
                            },
                            model: {
                              value: _vm.CustomerRegion3,
                              callback: function($$v) {
                                _vm.CustomerRegion3 = $$v
                              },
                              expression: "CustomerRegion3"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "BranchCriteriaId",
                            error: _vm.$v.form.BranchCriteriaId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: true,
                              label: "Label",
                              "lookup-key": "BRANCH_CRITERIA"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "BranchCriteriaId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.BranchCriteria,
                              callback: function($$v) {
                                _vm.BranchCriteria = $$v
                              },
                              expression: "BranchCriteria"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("insert.bcp.items") } },
                [
                  _c("NextDetailPanel", {
                    attrs: { type: "get", items: _vm.bcpDetailsItems },
                    model: {
                      value: _vm.form.BCPDetails,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "BCPDetails", $$v)
                      },
                      expression: "form.BCPDetails"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.CustomerRegion3 &&
              _vm.CustomerRegion3.Code !== null &&
              _vm.BranchCriteria &&
              _vm.BranchCriteria.Code == "SL"
                ? _c(
                    "b-tab",
                    {
                      attrs: { lazy: "", title: _vm.$t("insert.bcp.branchs") }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: { items: _vm.bcpBranchsItems },
                        model: {
                          value: _vm.form.BCPBranchs,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "BCPBranchs", $$v)
                          },
                          expression: "form.BCPBranchs"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cb9c60a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb9c60a6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Bcp/update.vue
// module id = null
// module chunks = 